import axios, { isCancel, type AxiosInstance } from 'axios';

export let axiosInstance: AxiosInstance;

export function isRequestCancelled(error: unknown): boolean {
  return isCancel(error);
}

export function initAxiosInstance(baseURL: string, modifyInstance: (instance: AxiosInstance) => void) {
  axiosInstance = axios.create({
    headers: { 'Content-Type': 'application/json' },
    baseURL,
    withCredentials: true,
  });

  modifyInstance(axiosInstance);
}
